import { render, staticRenderFns } from "./FaqCategories.vue?vue&type=template&id=2a1bcf48"
import script from "./FaqCategories.vue?vue&type=script&lang=ts"
export * from "./FaqCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports